import { render, staticRenderFns } from "./VrsCoordinatesMap.vue?vue&type=template&id=1e4b1cf6&scoped=true"
import script from "./VrsCoordinatesMap.vue?vue&type=script&lang=js"
export * from "./VrsCoordinatesMap.vue?vue&type=script&lang=js"
import style0 from "./VrsCoordinatesMap.vue?vue&type=style&index=0&id=1e4b1cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b1cf6",
  null
  
)

export default component.exports